import { useQuery } from 'react-query';

import { getTopRelationshipTypeChanges as queryFn } from 'api/endPoints/getTopRelationshipTypeChanges';

export const useQueryRelationshipTypeChangesTableData = (params) => {
    return useQuery(['relationshipTypeChangesTableData', params], () => queryFn(params), {
        enabled: Boolean(params.compareVersionId) && Boolean(params.latestVersionId),
    });
};
